import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import {
  Text
} from "@chakra-ui/react";

import {
  SectionContainer,
  SectionWrapper
} from "../components/Section";

import Layout from "../components/Layout";
import Head from "../components/Head";

import { CallToAction } from "../components/CallToAction";
import { Carousel } from "../components/Carousel";
import { Flexbox } from "../components/Flexbox";
import { PageHero } from "../components/Hero";
import { Ticker } from "../components/Ticker";


const ServicesPage: React.FC = () => {
  const data: any = useStaticQuery(graphql`
    query {
      page: mdx(
        frontmatter: {
          title: {
            eq: "Services"
          }
        }
      ) {
        frontmatter {
          seo_title
          seo_description
          heading
          subheading
          hero_image {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: TRACED_SVG
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          call_to_action_mobile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: TRACED_SVG
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          call_to_action_desktop {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: TRACED_SVG
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }

      benefits: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "benefit"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              icon
            }
          }
        }
      }

      services: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "service"
            }
          }
        }
        sort: {
          fields: [frontmatter___order]
          order: ASC
        }
      ) {
        edges {
          node {
            frontmatter {
              heading
              subheading
              description
              image {
                childImageSharp {
                  gatsbyImageData(
                    quality: 100
                    placeholder: TRACED_SVG
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }

      testimonials: allMdx(
        filter: {
          frontmatter: {
            template: {
              eq: "testimonial"
            }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              author_name
              author_title
              testimonial
            }
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <Head
        title={ data.page.frontmatter.seo_title }
        description={ data.page.frontmatter.seo_description }
      />

      <SectionWrapper
        background="background.aliceblue"
        padding="153px 0 138px"
      >
        <SectionContainer>
          <PageHero
            heading={ data.page.frontmatter.heading }
            image={ data.page.frontmatter.hero_image.childImageSharp.gatsbyImageData }
            alignment="left"
          />
        </SectionContainer>
      </SectionWrapper>

      <SectionWrapper>
        <CallToAction
          mobileImage={ data.page.frontmatter.call_to_action_mobile.childImageSharp.gatsbyImageData }
          desktopImage={ data.page.frontmatter.call_to_action_desktop.childImageSharp.gatsbyImageData }
        />
      </SectionWrapper>

      <SectionWrapper
        padding="120px 0 72px"
      >
        <SectionContainer>
          <Ticker
            itemWidth={ 280 }
            template="benefit"
            nodes={ data.benefits.edges }
          />
        </SectionContainer>
      </SectionWrapper>

      <SectionWrapper
        padding="72px 0"
      >
        <SectionContainer>
          <Flexbox
            nodes={ data.services.edges }
            layout="service"
            heading={
              <>
                Our <Text as="span" color="primary.900">services</Text> and expertise
              </>
            }
            headingWidth={{
              lg: '750px'
            }}
            description="Drobot Construction provides a full range of residential and commercial solutions. From single-family homes to large industrial facilities, we handle foundations for all types of properties in Toronto and throughout the Greater Toronto Area."
          />
        </SectionContainer>
      </SectionWrapper>

      <SectionWrapper
        background="background.aliceblue"
        padding="110px 0"
      >
        <Carousel
          nodes={ data.testimonials.edges }
          options={{
            loop: true
          }}
          template="testimonial"
          heading={
            <>
              People <Text as="span" color="primary.900">love</Text> what we do
            </>
          }
          headingAlignment="space-between"
        />
      </SectionWrapper>
    </Layout>
  )
}


export default ServicesPage;
